<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">部门管理</span>
      </div>
      <div class="right">
        <Button icon="md-add" type="primary" @click="openModal({}, '新增部门')"
          >新增一级部门</Button
        >
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>
        说明：通过为一级部门设置管理员，可实现对此部门的员工进行管理，并可查询统计部门员工的印量成本，以及作业记录（部门管理员登录方式：在企业管理员登录页面，使用此员工的员工账号和密码，即可登录）
      </div>
    </div>
    <div class="list-header">
      <div class="l">部门名称</div>
      <div class="r">操作</div>
    </div>
    <div class="cat_listBox">
      <div class="list_row" v-for="(item, index) in treeList" :key="index">
        <div class="text">
          <Icon
            :type="item.expand ? 'md-remove' : 'md-add'"
            class="icon"
            @click="open(item)"
          />
          <p class="span">
            {{ item.name }}
            <Icon
              v-if="item.admin_name"
              style="margin-left: 20px; margin-bottom: 3px"
              type="ios-person"
              :size="16"
              color="#2d8cf0"
            />
            <span>{{ item.admin_name ? item.admin_name : "" }}</span>
          </p>
          <div class="operate">
            <Button
              type="info"
              size="small"
              style="margin-right: 10px"
              @click="openModal({ parent_id: item.parent_id }, '新增部门')"
              >新增同级</Button
            >
            <Button
              type="info"
              size="small"
              style="margin-right: 10px"
              @click="openModal({ parent_id: item.id }, '新增部门')"
              >新增下级</Button
            >
            <Button
              type="success"
              size="small"
              style="margin-right: 10px"
              @click="openAdmin(item)"
              v-if="!company.power"
              >设置管理员</Button
            >
            <Button
              type="primary"
              size="small"
              @click="openModal(item, '修改部门')"
              style="margin-right: 10px"
              >编辑</Button
            >
            <Button
              type="error"
              size="small"
              @click="del(item)"
              v-if="!item.children"
              >删除</Button
            >
          </div>
        </div>
        <div
          class="row1"
          v-for="(val, key) in item.children"
          :key="key"
          v-show="item.expand"
        >
          <div class="text">
            <Icon
              :type="
                val.expand
                  ? 'md-remove'
                  : val.children
                  ? 'md-add'
                  : 'md-return-right'
              "
              class="icon"
              @click="open(val)"
            />
            <p class="span">{{ val.name }}</p>
            <div class="operate">
              <Button
                type="info"
                size="small"
                style="margin-right: 10px"
                @click="openModal({ parent_id: val.parent_id }, '新增部门')"
                >新增同级</Button
              >
              <Button
                type="info"
                size="small"
                style="margin-right: 10px"
                @click="openModal({ parent_id: val.id }, '新增部门')"
                >新增下级</Button
              >
              <Button
                type="primary"
                size="small"
                @click="openModal(val, '修改部门')"
                style="margin-right: 10px"
                >编辑</Button
              >
              <Button type="error" size="small" @click="del(val)">删除</Button>
            </div>
          </div>
          <div
            class="row1"
            v-for="(val2, key2) in val.children"
            :key="key2"
            v-show="val.expand"
          >
            <div class="text">
              <Icon type="md-return-right" class="icon" />
              <p class="span">{{ val2.name }}</p>
              <div class="operate">
                <Button
                  type="info"
                  size="small"
                  style="margin-right: 10px"
                  @click="openModal({ parent_id: val2.parent_id }, '新增部门')"
                  >新增同级</Button
                >
                <!-- <Button
                  type="info"
                  size="small"
                  style="margin-right: 10px"
                  @click="openModal({ parent_id: val2.id }, '新增部门')"
                  >新增下级</Button
                > -->
                <Button
                  type="primary"
                  size="small"
                  @click="openModal(val2, '修改部门')"
                  style="margin-right: 10px"
                  >编辑</Button
                >
                <Button type="error" size="small" @click="del(val2)"
                  >删除</Button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 部门编辑 -->
    <Modal v-model="modal.visible" :title="modal.title" :width="320">
      <Form
        ref="formInline"
        :model="modal.data"
        :rules="rule"
        :label-width="100"
        inline
      >
        <FormItem prop="name" label="部门名称:">
          <Input
            v-model="modal.data.name"
            placeholder="填写部门名称..."
            autofocus
          />
        </FormItem>
        <FormItem
          prop="parent"
          label="上级部门:"
          v-if="modal.data.id && modal.data.parent_id"
        >
          <Select v-model="modal.data.parent_id" style="width: 140px">
            <!-- v-if="modal.data.id !== item.id" -->
            <Option
              v-for="item in data"
              :value="item.id"
              :key="item.id"
              v-if="modal.data.id !== item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="modal.visible = false">取消</Button>
        <Button
          type="primary"
          size="large"
          @click="modalOk"
          :loading="modal.loading"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 设置部门管理员 -->
    <Modal
      :title="`设置管理员 - ${adminModal.name}`"
      v-model="adminModal.visible"
    >
      <Alert v-if="adminModal.admin_name"
        >该部门当前管理员为: {{ adminModal.admin_name }}</Alert
      >
      <Select
        v-model="adminModal.search"
        filterable
        remote
        clearable
        @on-change="changeAdmin"
        :loading="adminModal.loading"
      >
        <Option
          v-for="(item, index) in adminModal.data"
          :value="item.id"
          :key="index"
          >{{ item.name }}</Option
        >
      </Select>
      <div slot="footer">
        <Button @click="adminModal.visible = false">取消</Button>
        <Button type="primary" @click="setAdmin">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      data: [], // 所有数据
      dataObj: {}, // 所有数据 id 对象
      treeList: [],
      modal: {
        visible: false,
        data: {}, // 模态框数据
        title: "",
        loading: false,
      },
      rule: {
        name: [
          {
            required: true,
            message: "此项必填",
            trigger: "blur",
            type: "number",
            validator: (rule, value, callback) => {
              if (!this.modal.data.name) {
                callback(new Error("此项必填"));
              }
              callback();
            },
          },
        ],
      },
      adminModal: {
        visible: false,
        loading: false,
        data: [],
        search: "",
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions([
      "SaveDepartment",
      "GetDepartment",
      "DelDepartment",
      "SetDepartmentAdmin",
      "GetStaff",
    ]),
    getData() {
      this.GetDepartment().then((res) => {
        this.data = res;
        this.formatTreeData();
      });
    },
    formatTreeData() {
      let data = JSON.parse(JSON.stringify(this.data));
      let name;
      data.forEach(function (item) {
        delete item.children;
        item.expand = false;
      });
      let map = {};
      data.forEach(function (item) {
        map[item.id] = item;
      });
      let val = [];
      data.forEach(function (item) {
        let parent = map[item.parent_id];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      this.treeList = val;
      this.data.map((item) => {
        this.dataObj[item.id] = item;
      });
      console.log("数据", this.treeList);
    },
    openModal(data, title) {
      data = JSON.parse(JSON.stringify(data));
      this.$refs.formInline.resetFields();
      this.modal.data = data;
      this.modal.visible = true;
      this.modal.title = title;
    },
    modalOk() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          let data = {
            name: this.modal.data.name,
            parent_id: this.modal.data.parent_id || null,
            is_del: this.modal.data.is_del || 0,
          };
          let upds = [];
          let flag = true;
          this.data.map((item) => {
            if (
              item.name === this.modal.data.name &&
              item.id !== this.modal.data.id
            ) {
              flag = false;
            }
          });
          if (!flag) {
            this.$Message.error("不允许有重名部门");
            return;
          }
          if (this.modal.data.id) {
            data.id = this.modal.data.id;
            this.data.map((item) => {
              // old => item    new => data
              if (data.id === item.id && data.parent_id !== item.parent_id) {
                // 上级
                if (
                  this.dataObj[data.parent_id].paths.indexOf(item.paths) < 0
                ) {
                  data.paths =
                    this.dataObj[data.parent_id].paths + data.id + "-";
                  this.data.map((item) => {
                    if (
                      item.paths !== this.dataObj[data.id].paths &&
                      item.paths.indexOf(this.dataObj[data.id].paths) >= 0
                    ) {
                      upds.push({
                        id: item.id,
                        parent_id: data.id,
                        paths: data.paths + item.id + "-",
                      });
                    }
                  });
                } else {
                  // 下级
                  this.data.map((item) => {
                    if (
                      item.paths.indexOf(this.dataObj[data.id].paths) >= 0 &&
                      item.paths !== this.dataObj[data.id].paths
                    ) {
                      item.paths
                        .split("-")
                        .splice(item.paths.split("-").indexOf(`${data.id}`), 1)
                        .join("-");
                      let temp_path = JSON.parse(
                        JSON.stringify(item.paths)
                      ).split("-");
                      temp_path.splice(
                        temp_path.indexOf(data.id.toString()),
                        1
                      );
                      upds.push({
                        id: item.id,
                        parent_id: data.id,
                        paths: temp_path.join("-"),
                      });
                      if (data.parent_id === item.id) {
                        data.paths = temp_path.join("-") + data.id + "-";
                      }
                    }
                  });
                }
              }
            });
          }
          this.SaveDepartment({ data: data, upds: upds }).then((res) => {
            this.getData();
            this.modal.visible = false;
            this.modal.data = {};
          });
        }
      });
    },
    open(row) {
      if (row.children.length) {
        row.expand = !row.expand;
      }
    },
    del(row) {
      this.$Modal.confirm({
        title: "重要提醒",
        content: "您确定删除该部门吗？",
        onOk: () => {
          this.DelDepartment({ id: row.id }).then((res) => {
            if(res){
              this.$Message.success("操作成功");
              this.getData();
            }else{
              this.$Message.error("删除失败");
            }
          });
        },
      });
    },
    openAdmin(data) {
      let param = {
        p: 0,
        l: 1000,
        d_id: data.id,
      };
      this.GetStaff(param).then((res) => {
        this.adminModal = {
          visible: true,
          department_id: data.id,
          name: data.name,
          admin_name: data.admin_name,
          admin_id: data.staff_id,
          data: res.data,
          search: "",
        };
      });
    },
    changeAdmin(id) {
      let staff = {};
      this.adminModal.data.map((item) => {
        if (item.id === id) {
          staff = item;
        }
      });
      console.log('选择的员工',staff )
      this.adminModal.staff_id = staff.id;
      this.adminModal.select_staff = staff;
    },
    setAdmin() {
      if(!this.adminModal.select_staff.email){
        this.$Modal.warning({
            title: "重要提醒",
            content: "请先在员工档案编辑中为其配置邮箱地址，再指定为管理员！"
        });
        return;
      }

      this.SetDepartmentAdmin({
        department_id: this.adminModal.department_id,
        staff_id: this.adminModal.staff_id,
        admin_id: this.adminModal.admin_id,
      }).then((res) => {
        this.$Message.success("设置成功");
        this.adminModal.visible = false;
        this.getData();
      });
    },
  },
  computed: mapGetters({
    company: "company",
  }),
  watch: {},
};
</script>
<style lang='less'>
@import "./index.less";
</style>
